import { render, staticRenderFns } from "./queryviewcolumnstyle.vue?vue&type=template&id=0ca5e672&scoped=true&"
import script from "./queryviewcolumnstyle.vue?vue&type=script&lang=js&"
export * from "./queryviewcolumnstyle.vue?vue&type=script&lang=js&"
import style0 from "./queryviewcolumnstyle.vue?vue&type=style&index=0&id=0ca5e672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5e672",
  null
  
)

export default component.exports